import React, { useState, useContext, memo, Fragment, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Accordion,
  useAccordionButton,
  AccordionContext,
} from "react-bootstrap";
import { getUser } from "../../../../utilities/setting";
import { USER_ROLES, ROUTES } from "../../../../utilities/constant";
import DashboardIcon from '@mui/icons-material/Dashboard';
import UserListIcon from '@mui/icons-material/RecentActors';
import CampaignIcon from '@mui/icons-material/Campaign';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import RealtimeIcon from '@mui/icons-material/Update';
import RemarkIcon from '@mui/icons-material/RateReview';
import GroupsIcon from '@mui/icons-material/Groups';
import DialpadIcon from "@mui/icons-material/Dialpad";
import LocationIcon from '@mui/icons-material/LocationOn';
import BreakIcon from '@mui/icons-material/ExitToApp';
import CreditHistoryIcon from '@mui/icons-material/CreditScore';
import ReportsIcon from '@mui/icons-material/Description';
import VoiceLibraryIcon from '@mui/icons-material/VoiceChat';
import ActivityListIcon from '@mui/icons-material/ChecklistRtl';
import VoicePlanIcon from '@mui/icons-material/InterpreterMode';
import ModuleIcon from '@mui/icons-material/AppsOutage';
import NumberIcon from '@mui/icons-material/Tty';
import DataCenterIcon from '@mui/icons-material/LaptopMac';
import ServerManagementIcon from '@mui/icons-material/Router';
import TrunksIcon from '@mui/icons-material/Dialpad';
import ACLSettingIcon from '@mui/icons-material/FormatLineSpacing';
import CompanyIcon from '@mui/icons-material/Business';
import CallcenterListIcon from '@mui/icons-material/ListAlt';
import ExtensionIcon from '@mui/icons-material/Extension';
import ManageAgentIcon from '@mui/icons-material/SupportAgent';
import IVRIcon from '@mui/icons-material/PermPhoneMsg';
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import SmsIcon from "@mui/icons-material/Sms";

function CustomToggle({ children, eventKey, onClick, activeMenu }) {
  const { activeEventKey } = useContext(AccordionContext);
  const isExpanded = activeEventKey === eventKey;

  const decoratedOnClick = useAccordionButton(eventKey, (active) =>
    onClick({ state: !active, eventKey: eventKey })
  );

  return (
    <Link
      to="#"
      aria-expanded={isExpanded ? "true" : "false"}
      className={`nav-link ${isExpanded ? 'active' : ''}`}
      role="button"
      onClick={(e) => {
        decoratedOnClick();
      }}
    >
      {children}
    </Link>
  );
}

const VerticalNav = memo((props) => {
  const [activeMenu, setActiveMenu] = useState(false);
  const [active, setActive] = useState("");
  const [activeAccordionKey, setActiveAccordionKey] = useState(null);
  const [contentId, setContentId] = useState(undefined);
  const [userRole, setUserRole] = useState(undefined);
  const [activeModule, setActiveModules] = useState([]);
  const [moduleOperations, setModuleOperations] = useState({});
  const [loggedInUser, setLoggedInUser] = useState(null);
  //location
  let location = useLocation();

  useEffect(() => {
    getUser().then((resp) => {
      if (resp) {
        setLoggedInUser(resp);
        setUserRole(resp.role);
        setContentId(resp.id);
        if (resp?.acl_settings) {
          setModuleOperations(JSON.parse(resp.acl_settings.module_operations))
          const modules = getKeysWithTrueValues(JSON.parse(resp.acl_settings.module_operations));
          setActiveModules(modules);
        }
      }
    });
  }, []);

  function getKeysWithTrueValues(moduleOperations) {
    return Object.keys(moduleOperations).filter(key => {
        const permissions = moduleOperations[key];
        return Object.values(permissions).some(value => value === true);
    });
  }

  // Helper function to clear all active states except for the one being set
  const clearActiveStates = (exceptAccordionKey = null, newActiveValue = null) => {
    // Clear previous active state first (unless we're setting a new one)
    if (newActiveValue === null) {
      setActive("");
    }
    // Clear active menu state
    setActiveMenu(false);
    // Close accordions except the one specified
    if (exceptAccordionKey !== null) {
      if (activeAccordionKey !== exceptAccordionKey) {
        setActiveAccordionKey(exceptAccordionKey);
      }
    } else {
      // Close all accordions
      if (activeAccordionKey !== null) {
        setActiveAccordionKey(null);
      }
    }
  };

  return (
    <Fragment>
      <Accordion 
        as="ul" 
        className="navbar-nav iq-main-menu" 
        activeKey={activeAccordionKey}
        onSelect={(eventKey) => {
          // Close previous accordion if clicking the same one, otherwise open new one
          const newKey = activeAccordionKey === eventKey ? null : eventKey;
          setActiveAccordionKey(newKey);
          
          // Clear active state for all items when closing
          if (newKey === null) {
            setActive("");
            setActiveMenu(false);
          } else {
            // When opening a new accordion, clear other active states
            clearActiveStates(newKey);
          }
        }}
      >
        <li className="nav-item static-item">
          <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
            {/* <span className="default-icon">Home</span>
            <span className="mini-icon">-</span> */}
          </Link>
        </li>
        <li
          className={`${
            location.pathname === `/${ROUTES.DASHBOARD}` ? "active" : ""
          } nav-item `}
        >
          <Link
            className={`${
              location.pathname === `/${ROUTES.DASHBOARD}` ? "active" : ""
            } nav-link `}
            aria-current="page"
            to={`/${ROUTES.DASHBOARD}`}
            onClick={() => {
              // Clear all active states when Dashboard is clicked
              setActive("");
              setActiveAccordionKey(null);
              setActiveMenu(false);
            }}
          >
            <DashboardIcon sx={{ fontSize: 22, color: 'white' }} />
            <span className="item-name">Dashboard</span>
          </Link>
        </li>
        <li>
          <hr className="hr-horizontal" />
        </li>
        {/* <li className="nav-item static-item">
          <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
            <span className="default-icon">Pages</span>
            <span className="mini-icon">-</span>
          </Link>
        </li> */}

        {(userRole === USER_ROLES.SUPERADMIN 
        || (moduleOperations?.Users?.read && moduleOperations?.Users?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-user"
            bsPrefix={`nav-item ${active === "user" ? "active" : ""} `}
            onClick={() => {
              clearActiveStates(null, "user");
              setActive("user");
            }}
          >
                
                  <Link
                    className={`${
                      location.pathname === `/${ROUTES.USERS.LIST}`
                        ? "active"
                        : ""
                    } nav-link`}
                    to={`/${ROUTES.USERS.LIST}`}
                  >
                    <UserListIcon sx={{ fontSize: 25, color: 'white' }} />
                    <i className="sidenav-mini-icon"> U </i>
                    <span className="item-name">Users</span>
                  </Link>
  
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN ||
        (moduleOperations?.['Company List']?.read && moduleOperations?.['Company List']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-credits"
            bsPrefix={`nav-item ${active === "credits" ? "active" : ""} `}
            onClick={() => {
              clearActiveStates(null, "credits");
              setActive("credits");
            }}
          >
            <Link
                  className={`${
                    location.pathname === `/${ROUTES.COMPANIES.LIST}`
                      ? "active"
                      : ""
                  } nav-link`}
                  to={`/${ROUTES.COMPANIES.LIST}`}
                >
              <CompanyIcon sx={{ fontSize: 22, color: 'white' }} />
              <span style={{marginLeft: "15px"}} className="item-name">Company List</span>
            </Link>
          </Accordion.Item>
        )}

        <Accordion.Item
          hidden={userRole !== USER_ROLES.SUPERADMIN}
          as="li"
          eventKey="sidebar-licence-history-list"
          bsPrefix={`nav-item ${active === "licence-history" ? "active" : ""} `}
          onClick={() => {
            clearActiveStates(null, "licence-history");
            setActive("licence-history");
          }}
        >
          <Link
            className={`${
              location.pathname === `/${ROUTES.LICENCE_HISTORY.LIST}`
                ? "active"
                : ""
            } nav-link`}
            to={`/${ROUTES.LICENCE_HISTORY.LIST}`}
          >
            <CallcenterListIcon sx={{ fontSize: 22, color: 'white' }} />
            <span style={{marginLeft: "15px"}} className="item-name">Licence History</span>
          </Link>
        </Accordion.Item>

        {(userRole === USER_ROLES.SUPERADMIN ||
        (moduleOperations?.TRUNKS?.read && moduleOperations?.TRUNKS?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-trunks"
            bsPrefix={`nav-item ${active === "trunks" ? "active" : ""} `}
            onClick={() => {
              clearActiveStates(null, "trunks");
              setActive("trunks");
            }}
          >
                <Link
                  className={`${
                    location.pathname === `/${ROUTES.TRUNKS.LIST}`
                      ? "active"
                      : ""
                  } nav-link`}
                  to={`/${ROUTES.TRUNKS.LIST}`}
                >
                  <TrunksIcon sx={{ fontSize: 22, color: 'white' }} />
                  <i className="sidenav-mini-icon"> U </i>
                  <span className="item-name">Trunks</span>
                </Link>
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN ||
        (moduleOperations?.Campaigns?.read && moduleOperations?.Campaigns?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-campaigns"
            bsPrefix={`nav-item ${active === "campaigns" ? "active" : ""} `}
            onClick={() => {
              clearActiveStates(null, "campaigns");
              setActive("campaigns");
            }}
          >
            <Link
              className={`${
              location.pathname === `/${ROUTES.CAMPAIGNS.LIST}`
                ? "active"
                : ""
              } nav-link`}
              to={`/${ROUTES.CAMPAIGNS.LIST}`}
            >
              <CampaignIcon sx={{ fontSize: 22, color: 'white' }} />
              <span style={{marginLeft: "15px"}} className="item-name">Outbound Campaigns</span>
            </Link>
          </Accordion.Item>
        )}
        
        {(userRole === USER_ROLES.SUPERADMIN || 
        (moduleOperations['Contact Group']?.read && moduleOperations['Contact Group']?.view_permission) 
        || (moduleOperations['All Contacts']?.read && moduleOperations['All Contacts']?.view_permission)) && (
          <Accordion.Item
              as="li"
              eventKey="sidebar-contactGroup"
              bsPrefix={`nav-item ${active === "contactGroup" ? "active" : ""} `}
              onClick={() => {
                clearActiveStates("sidebar-contactGroup", "contactGroup");
                setActive("contactGroup");
              }}
            >
              <CustomToggle
                eventKey="sidebar-contactGroup"
                onClick={(activeKey) => {
                  setActiveMenu(activeKey);
                  if (activeAccordionKey !== activeKey.eventKey) {
                    setActiveAccordionKey(activeKey.eventKey);
                  } else {
                    setActiveAccordionKey(null);
                  }
                }}
                activeMenu={activeMenu}
              >
                <ContactPageIcon sx={{ fontSize: 22, color: 'white' }} />
                <span className="item-name">Contacts</span>
                <i className="right-icon">
                  <svg width="18" viewBox="0 0 24 24" stroke="white">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </i>
              </CustomToggle>

              <Accordion.Collapse eventKey="sidebar-contactGroup">
                <ul className="sub-nav" style={{ backgroundImage: "linear-gradient(80deg, #0d0884, rgb(6, 9, 12))" }}>
                {(userRole === USER_ROLES.SUPERADMIN || (moduleOperations['Contact Group']?.read && moduleOperations['Contact Group']?.view_permission)) && (
                  <li className="nav-item">
                    <Link
                      className={`${
                        location.pathname === `/${ROUTES.CONTACTGROUP.LIST}` ? "active" : ""
                      } nav-link`}
                      to={`/${ROUTES.CONTACTGROUP.LIST}`}
                    >
                      <i className="icon">
                        <svg width="10" viewBox="0 0 24 24" fill="white">
                          <circle cx="12" cy="12" r="8" fill="white" />
                        </svg>
                      </i>
                      <span className="item-name">Contact Group</span>
                    </Link>
                  </li>
                )} 

                {(userRole === USER_ROLES.SUPERADMIN || (moduleOperations['All Contacts']?.read && moduleOperations['All Contacts']?.view_permission)) && (
                  <li className="nav-item">
                    <Link
                      className={`${
                        location.pathname === `/${ROUTES.CONTACTGROUP.ALL_CONTACTS}` ? "active" : ""
                      } nav-link`}
                      to={`/${ROUTES.CONTACTGROUP.ALL_CONTACTS}`}
                    >
                      <i className="icon">
                        <svg width="10" viewBox="0 0 24 24" fill="white">
                          <circle cx="12" cy="12" r="8" fill="white" />
                        </svg>
                      </i>
                      <span className="item-name">All Contacts</span>
                    </Link>
                  </li>
                )}
                </ul>
              </Accordion.Collapse>
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN ||
        (moduleOperations?.Breaks?.read && moduleOperations?.Breaks?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-breaks"
            bsPrefix={`nav-item ${active === "breaks" ? "active" : ""} `}
            onClick={() => {
              clearActiveStates(null, "breaks");
              setActive("breaks");
            }}
          >
            <Link
              className={`${
              location.pathname === `/${ROUTES.BREAKS.LIST}`
                ? "active"
                : ""
              } nav-link`}
              to={`/${ROUTES.BREAKS.LIST}`}
            >
              <BreakIcon sx={{ fontSize: 22, color: 'white' }} />
              <span style={{marginLeft: "15px"}} className="item-name">Breaks</span>
            </Link>
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN ||
        (moduleOperations?.['Credit History']?.read && moduleOperations?.['Credit History']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-credits"
            bsPrefix={`nav-item ${active === "credits" ? "active" : ""} `}
            onClick={() => {
              clearActiveStates(null, "credits");
              setActive("credits");
            }}
          >
            <Link
              className={`${
              location.pathname === `/${ROUTES.CREDIT_HISTORY}`
                ? "active"
                : ""
              } nav-link`}
              to={`/${ROUTES.CREDIT_HISTORY}`}
            >
              <CreditHistoryIcon sx={{ fontSize: 22, color: 'white' }} />
              <span style={{marginLeft: "15px"}} className="item-name">Credit History</span>
            </Link>
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN ||
        (moduleOperations?.Numbers?.read && moduleOperations?.Numbers?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-numbers"
            bsPrefix={`nav-item ${active === "numbers" ? "active" : ""} `}
            onClick={() => {
              clearActiveStates("sidebar-numbers", "numbers");
              setActive("numbers");
            }}
          >
            <CustomToggle
              eventKey="sidebar-numbers"
              onClick={(activeKey) => {
                setActiveMenu(activeKey);
                if (activeAccordionKey !== activeKey.eventKey) {
                  setActiveAccordionKey(activeKey.eventKey);
                } else {
                  setActiveAccordionKey(null);
                }
              }}
              activeMenu = {activeMenu}
            >
              <NumberIcon sx={{ fontSize: 22, color: 'white' }} />

              <span className="item-name">Numbers</span>
              <i className="right-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="white"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </i>
            </CustomToggle>
            <Accordion.Collapse eventKey="sidebar-numbers">
              <ul className="sub-nav">
              {(userRole === USER_ROLES.SUPERADMIN ||
                (moduleOperations?.Numbers?.read && moduleOperations?.Numbers?.view_permission)) && (
                <>
                <li className="nav-item">
                <Link
                  className={`${
                    location.pathname === `/${ROUTES.NUMBERS.LIST}`
                      ? "active"
                      : ""
                  } nav-link`}
                  to={`/${ROUTES.NUMBERS.LIST}`}
                >
                  {/* <NumberIcon sx={{ fontSize: 22, color: 'white' }} /> */}
                  <i className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="white">
                      <g><circle cx="12" cy="12" r="8" fill="white"></circle></g>
                    </svg>
                  </i>
                  <span className="item-name">Numbers</span>
                </Link>
                </li>

                {(userRole === USER_ROLES.SUPERADMIN) && (
                <li className="nav-item">
                <Link
                  className={`${
                    location.pathname === `/${ROUTES.NUMBERS.NUMBER_FILE_LIST}`
                      ? "active"
                      : ""
                  } nav-link`}
                  to={`/${ROUTES.NUMBERS.NUMBER_FILE_LIST}`}
                >
                  <i className="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="white">
                      <g><circle cx="12" cy="12" r="8" fill="white"></circle></g>
                    </svg>
                  </i>
                  <span className="item-name">Numbers Files List</span>
                </Link>
                </li>
                )}

                {(
                  userRole === USER_ROLES.SUPERADMIN
                  ) && (
                    <li className="nav-item">
                    <Link
                      className={`${
                        location.pathname === `/${ROUTES.NUMBERS.STATUS_CHANGE_ACTION}`
                          ? "active"
                          : ""
                      } nav-link`}
                      to={`/${ROUTES.NUMBERS.STATUS_CHANGE_ACTION}`}
                    >
                      <i className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          viewBox="0 0 24 24"
                          fill="white"
                        >
                          <g>
                            <circle
                              cx="12"
                              cy="12"
                              r="8"
                              fill="white"
                            ></circle>
                          </g>
                        </svg>
                      </i>
                      <i className="sidenav-mini-icon"> U </i>
                      <span className="item-name">Status for approval</span>
                    </Link>
                    </li>
                )}

                  {(userRole === USER_ROLES.SUPERADMIN 
                ) && (
                    <li className="nav-item">
                    <Link
                      className={`${
                        location.pathname === `/${ROUTES.NUMBERS.DID_HISTORY}`
                          ? "active"
                          : ""
                      } nav-link`}
                      to={`/${ROUTES.NUMBERS.DID_HISTORY}`}
                    >
                      <i className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          viewBox="0 0 24 24"
                          fill="white"
                        >
                          <g>
                            <circle
                              cx="12"
                              cy="12"
                              r="8"
                              fill="white"
                            ></circle>
                          </g>
                        </svg>
                      </i>
                      <i className="sidenav-mini-icon"> U </i>
                      <span className="item-name">Historical DIDs</span>
                    </Link>
                    </li>
                )}
                </>
              )}  
              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        )}


        {(((moduleOperations?.['Call Centres List']?.read && moduleOperations?.['Call Centres List']?.view_permission))
        || (loggedInUser?.assignedCompany?.is_own_company)) &&
        <Accordion.Item
          as="li"
          eventKey="sidebar-call-centre"
          bsPrefix={`nav-item ${active === "call-centre" ? "active" : ""} `}
          onClick={() => {
            clearActiveStates(null, "call-centre");
            setActive("call-centre");
          }}
        >
            <ul className="sub-nav">
                <Link
                  className={`${
                    location.pathname === `/${ROUTES.CALL_CENTRES.LIST}`
                      ? "active"
                      : ""
                  } nav-link`}
                  to={`/${ROUTES.CALL_CENTRES.LIST}`}
                >
                  <CallcenterListIcon sx={{ fontSize: 22, color: 'white' }} />
                  <span className="item-name">Call Centres List</span>
                </Link>
            </ul>
        </Accordion.Item>
        }

        {((moduleOperations?.IVR?.read && moduleOperations?.IVR?.view_permission)
          || (moduleOperations?.['Voice Library']?.read && moduleOperations?.['Voice Library']?.view_permission)
          || (moduleOperations?.TTS?.read && moduleOperations?.TTS?.view_permission)) && (
          <Accordion.Item
              as="li"
              eventKey="sidebar-ivr"
              bsPrefix={`nav-item ${active === "ivr" ? "active" : ""} `}
              onClick={() => {
                clearActiveStates("sidebar-ivr", "ivr");
                setActive("ivr");
              }}
            >
              <CustomToggle
                eventKey="sidebar-ivr"
                onClick={(activeKey) => {
                  setActiveMenu(activeKey);
                  if (activeAccordionKey !== activeKey.eventKey) {
                    setActiveAccordionKey(activeKey.eventKey);
                  } else {
                    setActiveAccordionKey(null);
                  }
                }}
                activeMenu = {activeMenu}
              >
                <IVRIcon sx={{ fontSize: 22, color: 'white' }} />
                <span className="item-name">IVR</span>
                <i className="right-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="white"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </i>
              </CustomToggle>

              <Accordion.Collapse eventKey="sidebar-ivr">
                <ul className="sub-nav">
                  {/* Existing IVR List Item */}
                  {(activeModule.includes('IVR') && (
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname ===
                          `/${ROUTES.IVR.LIST.replace(":cid", contentId)}`
                            ? "active"
                            : ""
                        } nav-link`}
                        to={`/${ROUTES.IVR.LIST.replace(":cid", contentId)}`}
                      >
                        <i className="sidenav-mini-icon"> U </i>
                        <span className="item-name">IVR List</span>
                      </Link>
                    </li>
                  ))}


                  {/* Voice Library Section */}
                  {(
                    // userRole === USER_ROLES.CALL_CENTRE_ADMIN || 
                    activeModule.includes('Voice Library')) && (
                    <li className="nav-item">
                      <Accordion>
                        <Accordion.Item eventKey="voice-library" style={{ backgroundImage: "linear-gradient(80deg, #0d0884, rgb(6, 9, 12))"}}>
                          <CustomToggle
                            eventKey="voice-library"
                            onClick={(activeKey) => setActiveMenu(activeKey)}
                            activeMenu={activeMenu}
                          >
                            <VoiceLibraryIcon sx={{ fontSize: 22, color: 'white' }} />
                            <span className="item-name" >Voice Library</span>
                            <i className="right-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="white"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M9 5l7 7-7 7"
                                />
                              </svg>
                            </i>
                          </CustomToggle>

                          <Accordion.Collapse eventKey="voice-library">
                            <ul className="sub-nav" style={{ backgroundImage: "linear-gradient(80deg, #0d0884, rgb(6, 9, 12))"}}>
                              {(userRole === USER_ROLES.SUPERADMIN || moduleOperations?.['Voice Library']?.add) && (
                                <li className="nav-item">
                                  <Link
                                    className={`${
                                      location.pathname ===
                                      `/${ROUTES.IVR.ADD_VOICE}`
                                        ? "active"
                                        : ""
                                    } nav-link`}
                                    to={`/${ROUTES.IVR.ADD_VOICE}`}
                                  >
                                    <i className="icon">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="10"
                                        viewBox="0 0 24 24"
                                        fill="white"
                                      >
                                        <g>
                                          <circle cx="12" cy="12" r="8" fill="white"></circle>
                                        </g>
                                      </svg>
                                    </i>
                                    <span className="item-name">Add Voice Files</span>
                                  </Link>
                                </li>
                              )}

                            <li className="nav-item">
                                    <Link
                                      className={`${
                                        location.pathname === `/${ROUTES.VOICE_LIBRARY.VIEW_VOICE_FILES}`
                                          ? "active"
                                          : ""
                                      } nav-link`}
                                      to={`/${ROUTES.VOICE_LIBRARY.VIEW_VOICE_FILES}`}
                                    >
                                      <i className="icon">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="10"
                                          viewBox="0 0 24 24"
                                          fill="white"
                                        >
                                          <g>
                                            <circle cx="12" cy="12" r="8" fill="white"></circle>
                                          </g>
                                        </svg>
                                      </i>
                                      <span className="item-name">View Voice files</span>
                                    </Link>
                                  </li>
                            </ul>
                          </Accordion.Collapse>
                        </Accordion.Item>
                      </Accordion>
                    </li>
                  )}

                  {/* TTS Plans Section */}
                  {(
                    // userRole === USER_ROLES.CALL_CENTRE_ADMIN || 
                    activeModule.includes('TTS')) && (
                    <li className="nav-item">
                      <Accordion>
                        <Accordion.Item eventKey="voice-library" style={{ backgroundImage: "linear-gradient(80deg, #0d0884, rgb(6, 9, 12))"}}>
                          <CustomToggle
                            eventKey="voice-library"
                            onClick={(activeKey) => setActiveMenu(activeKey)}
                            activeMenu={activeMenu}
                          >
                            <VoiceLibraryIcon sx={{ fontSize: 22, color: 'white' }} />
                            <span className="item-name" >TTS</span>
                            <i className="right-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="white"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M9 5l7 7-7 7"
                                />
                              </svg>
                            </i>
                          </CustomToggle>

                          <Accordion.Collapse eventKey="voice-library">
                            <ul className="sub-nav" style={{ backgroundImage: "linear-gradient(80deg, #0d0884, rgb(6, 9, 12))"}}>
                              {(userRole === USER_ROLES.SUPERADMIN || moduleOperations?.['TTS']?.add) && ( 
                                <li className="nav-item">
                                  <Link
                                    className={`${
                                      location.pathname ===
                                      `/${ROUTES.TTS.CREATE}`
                                        ? "active"
                                        : ""
                                    } nav-link`}
                                    to={`/${ROUTES.TTS.CREATE}`}
                                  >
                                    <i className="icon">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="10"
                                        viewBox="0 0 24 24"
                                        fill="white"
                                      >
                                        <g>
                                          <circle cx="12" cy="12" r="8" fill="white"></circle>
                                        </g>
                                      </svg>
                                    </i>
                                    <span className="item-name">Add TTS </span>
                                  </Link>
                                </li>
                              )}
                            <li className="nav-item">
                                    <Link
                                      className={`${
                                        location.pathname === `/${ROUTES.TTS.LIST}`
                                          ? "active"
                                          : ""
                                      } nav-link`}
                                      to={`/${ROUTES.TTS.LIST}`}
                                    >
                                      <i className="icon">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="10"
                                          viewBox="0 0 24 24"
                                          fill="white"
                                        >
                                          <g>
                                            <circle cx="12" cy="12" r="8" fill="white"></circle>
                                          </g>
                                        </svg>
                                      </i>
                                      <span className="item-name">View TTS List</span>
                                    </Link>
                                  </li>
                            </ul>
                          </Accordion.Collapse>
                        </Accordion.Item>
                      </Accordion>
                    </li>
                  )}

                </ul>
              </Accordion.Collapse>

          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN ||
        (moduleOperations?.Groups?.read && moduleOperations?.Groups?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-manageGroups"
            bsPrefix={`nav-item ${active === "manageGroups" ? "active" : ""} `}
            onClick={() => {
              clearActiveStates("sidebar-manageGroups", "manageGroups");
              setActive("manageGroups");
            }}
          >
            <CustomToggle
              eventKey="sidebar-manageGroups"
              onClick={(activeKey) => {
                setActiveMenu(activeKey);
                if (activeAccordionKey !== activeKey.eventKey) {
                  setActiveAccordionKey(activeKey.eventKey);
                } else {
                  setActiveAccordionKey(null);
                }
              }}
              activeMenu={activeMenu}
            >
              <GroupsIcon sx={{ fontSize: 22, color: 'white' }} />
              <span className="item-name">Groups</span>
              <i className="right-icon">
                <svg width="18" viewBox="0 0 24 24" stroke="white">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </i>
            </CustomToggle>

            <Accordion.Collapse eventKey="sidebar-manageGroups">
              <ul
                className="sub-nav"
                style={{ backgroundImage: "linear-gradient(80deg, #0d0884, rgb(6, 9, 12))" }}
              >
                {/* Group List (your existing one) */}
                <li className="nav-item">
                  <Link
                    className={`${
                      location.pathname === `/${ROUTES.MANAGE_GROUPS.GROUP_LIST}` ? "active" : ""
                    } nav-link`}
                    to={`/${ROUTES.MANAGE_GROUPS.GROUP_LIST}`}
                  >
                    <i className="icon">
                      <svg width="10" viewBox="0 0 24 24" fill="white">
                        <circle cx="12" cy="12" r="8" fill="white" />
                      </svg>
                    </i>
                    <span className="item-name">Groups List</span>
                  </Link>
                </li>

                {/* Bulk Group Add */}
                <li className="nav-item">
                  <Link
                    className={`${
                      location.pathname === `/${ROUTES.MANAGE_GROUPS.BULK_ADD}` ? "active" : ""
                    } nav-link`}
                    to={`/${ROUTES.MANAGE_GROUPS.BULK_ADD}`}
                  >
                    <i className="icon">
                      <svg width="10" viewBox="0 0 24 24" fill="white">
                        <circle cx="12" cy="12" r="8" fill="white" />
                      </svg>
                    </i>
                    <span className="item-name">Bulk Group Add</span>
                  </Link>
                </li>

                {/* Bulk Group Delete */}
                <li className="nav-item">
                  <Link
                    className={`${
                      location.pathname === `/${ROUTES.MANAGE_GROUPS.BULK_DELETE}` ? "active" : ""
                    } nav-link`}
                    to={`/${ROUTES.MANAGE_GROUPS.BULK_DELETE}`}
                  >
                    <i className="icon">
                      <svg width="10" viewBox="0 0 24 24" fill="white">
                        <circle cx="12" cy="12" r="8" fill="white" />
                      </svg>
                    </i>
                    <span className="item-name">Bulk Group Delete</span>
                  </Link>
                </li>
              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN
        || (moduleOperations?.Locations?.read && moduleOperations?.Locations?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-manageLocations"
            bsPrefix={`nav-item ${active === "manageLocations" ? "active" : ""}`}
            onClick={() => {
              setActive("manageLocations");
              clearActiveStates("sidebar-manageLocations");
            }}
          >
            <CustomToggle
              eventKey="sidebar-manageLocations"
              onClick={(activeKey) => setActiveMenu(activeKey)}
              activeMenu={activeMenu}
            >
              <LocationIcon sx={{ fontSize: 22, color: 'white' }} />
              <span className="item-name">Locations</span>
              <i className="right-icon">
                <svg width="18" viewBox="0 0 24 24" stroke="white">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </i>
            </CustomToggle>

            <Accordion.Collapse eventKey="sidebar-manageLocations">
              <ul
                className="sub-nav"
                style={{ backgroundImage: "linear-gradient(80deg, #0d0884, rgb(6, 9, 12))" }}
              >
                {/* Location List */}
                <li className="nav-item">
                  <Link
                    className={`${
                      location.pathname === `/${ROUTES.MANAGE_LOCATIONS.LOCATION_LIST}` ? "active" : ""
                    } nav-link`}
                    to={`/${ROUTES.MANAGE_LOCATIONS.LOCATION_LIST}`}
                  >
                    <i className="icon">
                      <svg width="10" viewBox="0 0 24 24" fill="white">
                        <circle cx="12" cy="12" r="8" fill="white" />
                      </svg>
                    </i>
                    <span className="item-name">Location List</span>
                  </Link>
                </li>

                {/* Bulk Location Add */}
                <li className="nav-item">
                  <Link
                    className={`${
                      location.pathname === `/${ROUTES.MANAGE_LOCATIONS.BULK_ADD}` ? "active" : ""
                    } nav-link`}
                    to={`/${ROUTES.MANAGE_LOCATIONS.BULK_ADD}`}
                  >
                    <i className="icon">
                      <svg width="10" viewBox="0 0 24 24" fill="white">
                        <circle cx="12" cy="12" r="8" fill="white" />
                      </svg>
                    </i>
                    <span className="item-name">Bulk Location Add</span>
                  </Link>
                </li>

                {/* Bulk Location Delete */}
                <li className="nav-item">
                  <Link
                    className={`${
                      location.pathname === `/${ROUTES.MANAGE_LOCATIONS.BULK_DELETE}` ? "active" : ""
                    } nav-link`}
                    to={`/${ROUTES.MANAGE_LOCATIONS.BULK_DELETE}`}
                  >
                    <i className="icon">
                      <svg width="10" viewBox="0 0 24 24" fill="white">
                        <circle cx="12" cy="12" r="8" fill="white" />
                      </svg>
                    </i>
                    <span className="item-name">Bulk Location Delete</span>
                  </Link>
                </li>
              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN ||
        (moduleOperations?.['PBX Management']?.read && moduleOperations?.['PBX Management']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-manageDialers"
            bsPrefix={`nav-item ${active === "manageDialers" ? "active" : ""}`}
            onClick={() => {
              setActive("manageDialers");
              clearActiveStates();
            }}
          >
          <Link
                      className={`${
                        location.pathname === `/${ROUTES.MANAGE_DIALERS.DIALER_LISTING}`
                          ? "active"
                          : ""
                      } nav-link`}
                      to={`/${ROUTES.MANAGE_DIALERS.DIALER_LISTING}`}
                    >
              <DialpadIcon sx={{ fontSize: 22, color: "white" }} />  {/* <-- use a Dialer icon */}
              <span className="item-name">PBX Management</span>
            </Link>
          </Accordion.Item>
        )}


        {((moduleOperations?.['Reports']?.read && moduleOperations?.['Reports']?.view_permission) 
        || (moduleOperations?.['Incoming Summary']?.read && moduleOperations?.['Incoming Summary']?.view_permission) 
        || (moduleOperations?.['Download Report']?.read && moduleOperations?.['Download Report']?.view_permission)) && (
          <Accordion.Item
              as="li"
              eventKey="sidebar-reports"
              bsPrefix={`nav-item ${active === "reports" ? "active" : ""}`}
              onClick={() => {
                clearActiveStates("sidebar-reports", "reports");
                setActive("reports");
              }}
            >
              <CustomToggle
                eventKey="sidebar-reports"
                onClick={(activeKey) => {
                  setActiveMenu(activeKey);
                  if (activeAccordionKey !== activeKey.eventKey) {
                    setActiveAccordionKey(activeKey.eventKey);
                  } else {
                    setActiveAccordionKey(null);
                  }
                }}
                activeMenu={activeMenu}
              >
              <ReportsIcon sx={{ fontSize: 22, color: 'white' }} />
                <span className="item-name">Reports</span>
                <i className="right-icon">
                  <svg width="18" viewBox="0 0 24 24" stroke="white">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </i>
              </CustomToggle>

              <Accordion.Collapse eventKey="sidebar-reports">
                <ul className="sub-nav" style={{ backgroundImage: "linear-gradient(80deg, #0d0884, rgb(6, 9, 12))" }}>
                  {((moduleOperations?.['Incoming Summary']?.read && moduleOperations?.['Incoming Summary']?.view_permission)) && (
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname === `/${ROUTES.IVR.INCOMING_SUMMARY}` ? "active" : ""
                        } nav-link`}
                        to={`/${ROUTES.IVR.INCOMING_SUMMARY}`}
                      >
                        <i className="icon">
                          <svg width="10" viewBox="0 0 24 24" fill="white">
                            <circle cx="12" cy="12" r="8" fill="white" />
                          </svg>
                        </i>
                        <span className="item-name">Incoming Summary</span>
                      </Link>
                    </li>
                  )}

                  {(moduleOperations?.['Download Report']?.read && moduleOperations?.['Download Report']?.view_permission) && (
                    <li className="nav-item">
                      <Link
                        className={`${
                          location.pathname === `/${ROUTES.IVR.DOWNLOAD_REPORT}` ? "active" : ""
                        } nav-link`}
                        to={`/${ROUTES.IVR.DOWNLOAD_REPORT}`}
                      >
                        <i className="icon">
                          <svg width="10" viewBox="0 0 24 24" fill="white">
                            <circle cx="12" cy="12" r="8" fill="white" />
                          </svg>
                        </i>
                        <span className="item-name">Download Reports</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </Accordion.Collapse>
          </Accordion.Item>
        )}


        {(userRole === USER_ROLES.SUPERADMIN
        || (moduleOperations?.['Data Center']?.read && moduleOperations?.['Data Center']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-datacenter"
            bsPrefix={`nav-item ${active === "dataCenter" ? "active" : ""} `}
            onClick={() => {
              setActive("dataCenter");
              clearActiveStates();
            }}
          >
                  <Link
                    className={`${
                      location.pathname === `/${ROUTES.DATA_CENTER.LIST}`
                        ? "active"
                        : ""
                    } nav-link`}
                    to={`/${ROUTES.DATA_CENTER.LIST}`}
                  >
                    <DataCenterIcon sx={{ fontSize: 22, color: 'white' }} />
                    <i className="sidenav-mini-icon"> U </i>
                    <span className="item-name">Data Center</span>
                  </Link>         
          </Accordion.Item>
        )}

        {((moduleOperations?.['SMS Webhook']?.read && moduleOperations?.['SMS Webhook']?.view_permission)) && (
            <Accordion.Item
            as="li"
            eventKey="sidebar-sms-webhook"
            bsPrefix={`nav-item ${active === "smsWebhook" ? "active" : ""} `}
            onClick={() => {
              setActive("smsWebhook");
              if (activeAccordionKey !== "sidebar-sms-webhook") {
                setActiveAccordionKey("sidebar-sms-webhook");
              }
            }}
          >
            <CustomToggle
              eventKey="sidebar-sms-webhook"
              onClick={(activeKey) => {
                setActiveMenu(activeKey);
                if (activeAccordionKey !== activeKey.eventKey) {
                  setActiveAccordionKey(activeKey.eventKey);
                } else {
                  setActiveAccordionKey(null);
                }
              }}
              activeMenu={activeMenu}
            >
              <SmsIcon sx={{ fontSize: 22, color: "white" }} />
              <span className="item-name">Sms Webhooks</span>
              <i className="right-icon">
                <svg width="18" viewBox="0 0 24 24" stroke="white">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </i>
            </CustomToggle>

            <Accordion.Collapse eventKey="sidebar-sms-webhook">
              <ul
                className="sub-nav"
                style={{
                  backgroundImage:
                    "linear-gradient(80deg, #0d0884, rgb(6, 9, 12))",
                }}
              >
                <li className="nav-item">
                  <Link
                    className={`${
                      location.pathname === `/${ROUTES.SMSWEBHOOK.LIST}`
                        ? "active"
                        : ""
                    } nav-link`}
                    to={`/${ROUTES.SMSWEBHOOK.LIST}`}
                  >
                    <i className="icon">
                      <svg width="10" viewBox="0 0 24 24" fill="white">
                        <circle cx="12" cy="12" r="8" fill="white" />
                      </svg>
                    </i>
                    <span className="item-name">View Webhooks</span>
                  </Link>
                </li>
                 
                {(userRole === USER_ROLES.SUPERADMIN || moduleOperations?.['SMS Webhook']?.add) && (
                  <li className="nav-item">
                    <Link
                      className={`${
                        location.pathname === `/${ROUTES.SMSWEBHOOK.CREATE}`
                          ? "active"
                          : ""
                      } nav-link`}
                      to={`/${ROUTES.SMSWEBHOOK.CREATE}`}
                    >
                      <i className="icon">
                        <svg width="10" viewBox="0 0 24 24" fill="white">
                          <circle cx="12" cy="12" r="8" fill="white" />
                        </svg>
                      </i>
                      <span className="item-name">Add Webhook</span>
                    </Link>
                  </li>
                )} 
              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        )}

        {((moduleOperations?.['Webhook']?.read && moduleOperations?.['Webhook']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-manage-webhook"
            bsPrefix={`nav-item ${active === "manageWebhook" ? "active" : ""} `}
            onClick={() => {
              setActive("manageWebhook");
              if (activeAccordionKey !== "sidebar-manage-webhook") {
                setActiveAccordionKey("sidebar-manage-webhook");
              }
            }}
          >
            <CustomToggle
              eventKey="sidebar-manage-webhook"
              onClick={(activeKey) => {
                setActiveMenu(activeKey);
                if (activeAccordionKey !== activeKey.eventKey) {
                  setActiveAccordionKey(activeKey.eventKey);
                } else {
                  setActiveAccordionKey(null);
                }
              }}
              activeMenu={activeMenu}
            >
              <SyncAltIcon sx={{ fontSize: 22, color: 'white' }} />
              <span className="item-name">Manage Webhook</span>
              <i className="right-icon">
                <svg width="18" viewBox="0 0 24 24" stroke="white">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              </i>
            </CustomToggle>

            <Accordion.Collapse eventKey="sidebar-manage-webhook">
              <ul className="sub-nav" style={{ backgroundImage: "linear-gradient(80deg, #0d0884, rgb(6, 9, 12))" }}>
                {(userRole === USER_ROLES.SUPERADMIN || moduleOperations?.Webhook?.add) && (
                  <li className="nav-item">
                    <Link
                      className={`${
                        location.pathname === `/${ROUTES.MANAGE_WEBHOOK.CREATE}` ? "active" : ""
                      } nav-link`}
                      to={`/${ROUTES.MANAGE_WEBHOOK.CREATE}`}
                    >
                      <i className="icon">
                        <svg width="10" viewBox="0 0 24 24" fill="white">
                          <circle cx="12" cy="12" r="8" fill="white" />
                        </svg>
                      </i>
                      <span className="item-name">Add Webhook</span>
                    </Link>
                  </li>
                )}
                <li className="nav-item">
                  <Link
                    className={`${
                      location.pathname === `/${ROUTES.MANAGE_WEBHOOK.LIST}` ? "active" : ""
                    } nav-link`}
                    to={`/${ROUTES.MANAGE_WEBHOOK.LIST}`}
                  >
                    <i className="icon">
                      <svg width="10" viewBox="0 0 24 24" fill="white">
                        <circle cx="12" cy="12" r="8" fill="white" />
                      </svg>
                    </i>
                    <span className="item-name">View Webhook</span>
                  </Link>
                </li>
              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN
        || (moduleOperations?.['Manage Prompts']?.read && moduleOperations?.['Manage Prompts']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-voice-library"
            bsPrefix={`nav-item ${active === "voiceLibrary" ? "active" : ""} `}
            onClick={() => {
              setActive("voiceLibrary");
              clearActiveStates();
            }}
          >
                  <Link
                    className={`${
                      location.pathname === `/${ROUTES.VOICE_LIBRARY.MANAGE_PROMPTS}`
                        ? "active"
                        : ""
                    } nav-link`}
                    to={`/${ROUTES.VOICE_LIBRARY.MANAGE_PROMPTS}`}
                  >
                    <VoiceLibraryIcon sx={{ fontSize: 22, color: 'white' }} />
                    <span className="item-name">Manage Prompts</span>
                  </Link>
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN
        || (moduleOperations?.['Gateway Management']?.read && moduleOperations?.['Gateway Management']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-servermanagement"
            bsPrefix={`nav-item ${
              active === "serverManagement" ? "active" : ""
            } `}
            onClick={() => {
              setActive("serverManagement");
              clearActiveStates();
            }}
          >
                <Link
                  className={`${
                    location.pathname === `/${ROUTES.SERVER_MANAGEMENT.LIST}`
                      ? "active"
                      : ""
                  } nav-link`}
                  to={`/${ROUTES.SERVER_MANAGEMENT.LIST}`}
                >
                  <ServerManagementIcon sx={{ fontSize: 22, color: 'white' }} />
                  <i className="sidenav-mini-icon"> U </i>
                  <span className="item-name">Gateway Management</span>
                </Link>
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN 
        || (moduleOperations?.['Module List']?.read && moduleOperations?.['Module List']?.view_permission)
        || (moduleOperations?.['ACL Setting List']?.read && moduleOperations?.['ACL Setting List']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-module"
            bsPrefix={`nav-item ${
              active === "module" ? "active" : ""
            } `}
            onClick={() => {
              setActive("module");
              if (activeAccordionKey !== "sidebar-module") {
                setActiveAccordionKey("sidebar-module");
              }
            }}
          >
            <CustomToggle
              eventKey="sidebar-module"
              onClick={(activeKey) => {
                setActiveMenu(activeKey);
                if (activeAccordionKey !== activeKey.eventKey) {
                  setActiveAccordionKey(activeKey.eventKey);
                } else {
                  setActiveAccordionKey(null);
                }
              }}
              activeMenu = {activeMenu}
            >
              <ModuleIcon sx={{ fontSize: 22, color: 'white' }} />
              <span className="item-name">Module</span>
              <i className="right-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="white"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </i>
            </CustomToggle>
            <Accordion.Collapse eventKey="sidebar-module">
              <ul className="sub-nav">
                {(userRole === USER_ROLES.SUPERADMIN || (moduleOperations?.['Module List']?.read && moduleOperations?.['Module List']?.view_permission)) && (
                  <li className="nav-item">
                    <Link
                      className={`${
                        location.pathname === `/${ROUTES.MODULE.LIST}`
                          ? "active"
                          : ""
                      } nav-link`}
                      to={`/${ROUTES.MODULE.LIST}`}
                    >
                      <i className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          viewBox="0 0 24 24"
                          fill="white"
                        >
                          <g>
                            <circle
                              cx="12"
                              cy="12"
                              r="8"
                              fill="white"
                            ></circle>
                          </g>
                        </svg>
                      </i>
                      <i className="sidenav-mini-icon"> U </i>
                      <span className="item-name">Module List</span>
                    </Link>
                  </li>
                )}

                {(userRole === USER_ROLES.SUPERADMIN || (moduleOperations?.['ACL Setting List']?.read && moduleOperations?.['ACL Setting List']?.view_permission)) && (
                  <li className="nav-item">
                    <Link
                      className={`${
                        location.pathname === `/${ROUTES.ACL_SETTING.LIST}`
                          ? "active"
                          : ""
                      } nav-link`}
                      to={`/${ROUTES.ACL_SETTING.LIST}`}
                    >
                      <i className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          viewBox="0 0 24 24"
                          fill="white"
                        >
                          <g>
                            <circle
                              cx="12"
                              cy="12"
                              r="8"
                              fill="white"
                            ></circle>
                          </g>
                        </svg>
                      </i>
                      <i className="sidenav-mini-icon"> U </i>
                      <span className="item-name">ACL Setting List</span>
                    </Link>
                  </li>
                )}


              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        )}

        {((moduleOperations?.['Agents']?.read && moduleOperations?.['Agents']?.view_permission)
        || (moduleOperations?.['Call Group']?.read && moduleOperations?.['Call Group']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-manage-agents"
            bsPrefix={`nav-item ${active === "manageAgents" ? "active" : ""} `}
            onClick={() => {
              setActive("manageAgents");
              if (activeAccordionKey !== "sidebar-manage-agents") {
                setActiveAccordionKey("sidebar-manage-agents");
              }
            }}
          >
            <CustomToggle
              eventKey="sidebar-manage-agents"
              onClick={(activeKey) => {
                setActiveMenu(activeKey);
                if (activeAccordionKey !== activeKey.eventKey) {
                  setActiveAccordionKey(activeKey.eventKey);
                } else {
                  setActiveAccordionKey(null);
                }
              }}
              activeMenu={activeMenu}
            >
              <ManageAgentIcon sx={{ fontSize: 22, color: 'white' }} />
              <span className="item-name">Manage Agents</span>
              <i className="right-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="white"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </i>
            </CustomToggle>
            <Accordion.Collapse eventKey="sidebar-manage-agents">
              <ul className="sub-nav">
                {/* Agents Link */}
                {(moduleOperations?.['Agents']?.read && moduleOperations?.['Agents']?.view_permission) && (
                  <li className="nav-item">
                    <Link
                      className={`${
                        location.pathname === `/${ROUTES.MANAGE_AGENTS.AGENTS}`
                          ? "active"
                          : ""
                      } nav-link`}
                      to={`/${ROUTES.MANAGE_AGENTS.AGENTS}`}
                    >
                      <i className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          viewBox="0 0 24 24"
                          fill="white"
                        >
                          <g>
                            <circle cx="12" cy="12" r="8" fill="white"></circle>
                          </g>
                        </svg>
                      </i>
                      <span className="item-name">Agents</span>
                    </Link>
                  </li>
                )}

                {/* Agent Group Link */}
                {((moduleOperations?.['Call Group']?.read && moduleOperations?.['Call Group']?.view_permission)) && (
                <li className="nav-item">
                  <Link
                    className={`${
                      location.pathname === `/${ROUTES.MANAGE_AGENTS.AGENT_GROUP_LIST}`
                        ? "active"
                        : ""
                    } nav-link`}
                    to={`/${ROUTES.MANAGE_AGENTS.AGENT_GROUP_LIST}`}
                  >
                    <i className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        viewBox="0 0 24 24"
                        fill="white"
                      >
                        <g>
                          <circle cx="12" cy="12" r="8" fill="white"></circle>
                        </g>
                      </svg>
                    </i>
                    <span className="item-name">Call Group</span>
                  </Link>
                </li>
                )}

              </ul>
            </Accordion.Collapse>
          </Accordion.Item>
        )}

        {((moduleOperations?.['Extension']?.read && moduleOperations?.['Extension']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-credits"
            bsPrefix={`nav-item ${active === "credits" ? "active" : ""} `}
            onClick={() => {
              clearActiveStates(null, "credits");
              setActive("credits");
            }}
          >
            <Link
                    className={`${
                      location.pathname === `/${ROUTES.MANAGE_AGENTS.EXTENSION}`
                        ? "active"
                        : ""
                    } nav-link`}
                    to={`/${ROUTES.MANAGE_AGENTS.EXTENSION}`}
                  >
              <ExtensionIcon sx={{ fontSize: 22, color: 'white' }} />
              <span style={{marginLeft: "15px"}} className="item-name">Extension</span>
            </Link>
          </Accordion.Item>
        )}

        <Accordion.Item
          hidden={userRole !== USER_ROLES.SUPERADMIN}
          as="li"
          eventKey="sidebar-agent-file-list"
          bsPrefix={`nav-item ${active === "agent-file-list" ? "active" : ""} `}
          onClick={() => {
            setActive("agent-file-list");
            clearActiveStates();
          }}
        >
          <Link
            className={`${
              location.pathname === `/${ROUTES.MANAGE_AGENTS.AGENT_FILE_LIST}`
                ? "active"
                : ""
            } nav-link`}
            to={`/${ROUTES.MANAGE_AGENTS.AGENT_FILE_LIST}`}
          >
            <CallcenterListIcon sx={{ fontSize: 22, color: 'white' }} />
            <span style={{marginLeft: "15px"}} className="item-name">Agent file list</span>
          </Link>
        </Accordion.Item>

        {/* Licence History List - Top Level Menu Item for Superadmin Only */}
        {/* <Accordion.Item
          hidden={userRole !== USER_ROLES.SUPERADMIN}
          as="li"
          eventKey="sidebar-licence-history-list"
          bsPrefix={`nav-item ${active === "licence-history-list" ? "active" : ""} `}
          onClick={() => {
            setActive("licence-history-list");
            clearActiveStates();
          }}
        >
          <Link
            className={`${
              location.pathname === `/${ROUTES.LICENCE_HISTORY.LIST}`
                ? "active"
                : ""
            } nav-link`}
            to={`/${ROUTES.LICENCE_HISTORY.LIST}`}
          >
            <CallcenterListIcon sx={{ fontSize: 22, color: 'white' }} />
            <span style={{marginLeft: "15px"}} className="item-name">Licence History</span>
          </Link>
        </Accordion.Item> */}

        {/* Activity List - with module operations check */}
        {(userRole === USER_ROLES.SUPERADMIN
        || (moduleOperations?.['Activity List']?.read && moduleOperations?.['Activity List']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-journeyoperation"
            bsPrefix={`nav-item ${
              active === "journeyOperation" ? "active" : ""
            } `}
            onClick={() => {
              setActive("journeyOperation");
              clearActiveStates();
            }}
          >
            <Link
              className={`${
                location.pathname === `/${ROUTES.JOURNEY_OPERATION.LIST}`
                  ? "active"
                  : ""
              } nav-link`}
              to={`/${ROUTES.JOURNEY_OPERATION.LIST}`}
            >
              <ActivityListIcon sx={{ fontSize: 22, color: 'white' }} />
              <i className="sidenav-mini-icon"> U </i>
              <span className="item-name">Activity List</span>
            </Link>
          </Accordion.Item>
        )}

        {/* Voice Plans - with module operations check */}
        {(userRole === USER_ROLES.SUPERADMIN
        || (moduleOperations?.['Voice Plans']?.read && moduleOperations?.['Voice Plans']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-credits"
            bsPrefix={`nav-item ${active === "credits" ? "active" : ""} `}
            onClick={() => {
              clearActiveStates(null, "credits");
              setActive("credits");
            }}
          >
            <Link
                  className={`${
                    location.pathname === `/${ROUTES.VOICE_PLAN.LIST}`
                      ? "active"
                      : ""
                  } nav-link`}
                  to={`/${ROUTES.VOICE_PLAN.LIST}`}
                >
              <VoicePlanIcon sx={{ fontSize: 22, color: 'white' }} />
              <span style={{marginLeft: "15px"}} className="item-name">Voice Plans</span>
            </Link>
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN
        || (moduleOperations?.['TTS Plans']?.read && moduleOperations?.['TTS Plans']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-tts-plans"
            bsPrefix={`nav-item ${active === "tts_plans" ? "active" : ""} `}
            onClick={() => {
              setActive("tts_plans");
              clearActiveStates();
            }}
          >
            <Link
                  className={`${
                    location.pathname === `/${ROUTES.TTSPLANS.LIST}`
                      ? "active"
                      : ""
                  } nav-link`}
                  to={`/${ROUTES.TTSPLANS.LIST}`}
                >
              <VoicePlanIcon sx={{ fontSize: 22, color: 'white' }} />
              <span style={{marginLeft: "15px"}} className="item-name">TTS Plans</span>
            </Link>
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN
        || (moduleOperations?.['Realtime']?.read && moduleOperations?.['Realtime']?.view_permission)) && (
          <Accordion.Item
            as="li"
            eventKey="sidebar-credits"
            bsPrefix={`nav-item ${active === "credits" ? "active" : ""} `}
            onClick={() => {
              clearActiveStates(null, "credits");
              setActive("credits");
            }}
          >
            <Link
                  className={`${
                    location.pathname === `/${ROUTES.REALTIME.LIST}`
                      ? "active"
                      : ""
                  } nav-link`}
                  to={`/${ROUTES.REALTIME.LIST}`}
                >
              <RealtimeIcon sx={{ fontSize: 22, color: 'white' }} />
              <span style={{marginLeft: "15px"}} className="item-name">Realtime</span>
            </Link>
          </Accordion.Item>
        )}

        {(userRole === USER_ROLES.SUPERADMIN
        || (moduleOperations?.['Remarks Status']?.read && moduleOperations?.['Remarks Status']?.view_permission)) && (
          <Accordion.Item
            hidden={
              !(userRole === USER_ROLES.SUPERADMIN || activeModule.includes('Remarks Status'))
            }
            as="li"
            eventKey="sidebar-credits"
            bsPrefix={`nav-item ${active === "credits" ? "active" : ""} `}
            onClick={() => {
              clearActiveStates(null, "credits");
              setActive("credits");
            }}
          >
            <Link
                  className={`${
                    location.pathname === `/${ROUTES.REMARKS.LIST}`
                      ? "active"
                      : ""
                  } nav-link`}
                  to={`/${ROUTES.REMARKS.LIST}`}
                >
              <RemarkIcon sx={{ fontSize: 22, color: 'white' }} />
              <span style={{marginLeft: "15px"}} className="item-name">Remarks Status</span>
            </Link>
          </Accordion.Item>
        )}

        <li>
          <hr className="hr-horizontal" />
        </li>
      </Accordion>
    </Fragment>
  );
});

export default VerticalNav;
